import { render, staticRenderFns } from "./ProductVariantShipping.vue?vue&type=template&id=b1d5a148&lang=pug&"
import script from "./ProductVariantShipping.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProductVariantShipping.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports